import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DevicesService } from 'src/app/_services/devices.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { LoaderService } from 'src/app/_services/loader.service';
import { UserProfileService } from '../../../_services/user-profile.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {

  todayDate = new Date();
  purchasesInTheMonth = 0;
  pointsForReferrals = 0;
  shoppingPointsMonth = 0;
  gessiPoints  = 0;
  pointsToBeat = 0;
  periodInDays = 0;
  spentPoints = 0;
  daysToExpire = 0;

  diviceXs: boolean;
  diviceSm: boolean;

  referredPurchases: any[] = [];
  ownPurchases: any[] = [];

  constructor(public firebaseAuthService: FirebaseAuthService, private devicesService: DevicesService,
    private userProfileService: UserProfileService, public loaderService: LoaderService) { }

  ngOnInit(): void {
    this.loaderService.isLoading = new BehaviorSubject(true);

    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });

    this.getConfig();
    // this.getSummaryData();

  }

  getConfig() {

    this.userProfileService.getPointsConfig().subscribe(pointsConfig => {

      this.daysToExpire = pointsConfig.data.pointsExpirationDays;
      this.periodInDays = this.daysToExpire;
      // this.loaderService.isLoading = new BehaviorSubject(false);
      this.getSummaryData()


    });
  }

  async getSummaryData() {
    // this.loaderService.isLoading = new BehaviorSubject(true);
    const token = await this.firebaseAuthService.publicUser.getIdToken();
    console.log('obtener puntos');

    this.userProfileService.getPointsRegisterHistoryByUser(this.firebaseAuthService.publicUser.uid,
      this.daysToExpire, token).subscribe(answ => {
        console.log(answ);
        this.processPointRegisterHistory(answ.data);
        this.loaderService.isLoading = new BehaviorSubject(false);
      });
  }


  processPointRegisterHistory(pointsRegisterHistory: any[]) {

    pointsRegisterHistory.forEach(entry => {

      if (entry.operationType === 'compra_referido') {
        this.referredPurchases.push(entry);
        this.pointsForReferrals += entry.points;

      } else if (entry.operationType === 'compra_propia') {
        this.ownPurchases.push(entry);
        this.shoppingPointsMonth += entry.points;
      }

      this.gessiPoints += entry.points;
      this.purchasesInTheMonth = this.ownPurchases.length;

    });



  }

}
